import { render, staticRenderFns } from "./SocialSalaryForm.vue?vue&type=template&id=0194f1a9&scoped=true&lang=html&"
import script from "./SocialSalaryForm.vue?vue&type=script&lang=js&"
export * from "./SocialSalaryForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialSalaryForm.vue?vue&type=style&index=0&id=0194f1a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194f1a9",
  null
  
)

export default component.exports